import { QueryStore } from '../runtime/stores/query'
import artifact from '$houdini/artifacts/InterchangeRecords'
import { initClient } from '$houdini/plugins/houdini-svelte/runtime/client'

export class InterchangeRecordsStore extends QueryStore {
	constructor() {
		super({
			artifact,
			storeName: "InterchangeRecordsStore",
			variables: false,
		})
	}
}

export async function load_InterchangeRecords(params) {
  await initClient()

	const store = new InterchangeRecordsStore()

	await store.fetch(params)

	return {
		InterchangeRecords: store,
	}
}
